import Button from '../../Button/Button.es.js';
import styled from 'styled-components';
import '../../../utils/assertions.es.js';
import 'react';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { palette, fontSize } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Group } from '../../../primitives/Group/Group.es.js';
import { Text } from '../../Text/Text.es.js';
var StyledToggleFilterPopupButton = styled(Button).withConfig({
  componentId: "sc-1qmri2f-0"
})(["color:", ";:hover{color:", ";}"], function (_ref) {
  var hasSelected = _ref.hasSelected;
  return hasSelected ? palette("neutral.0") : palette("neutral.400");
}, palette("neutral.0"));
var StyledGroupItem = styled(Group.Item).withConfig({
  componentId: "sc-1qmri2f-1"
})([""]);
var MobileToggleResponsiveMenuButtonWrapper = styled.div.withConfig({
  componentId: "sc-1qmri2f-2"
})(["display:flex;"]);
var MobileAppliedFiltersListItem = styled.button.withConfig({
  componentId: "sc-1qmri2f-3"
})(["font-size:", ";color:", ";display:flex;max-width:60%;padding:0;align-items:center;outline:none;svg{flex-shrink:0;}"], fontSize("md"), palette("neutral.400"));
var MobileAppliedFiltersListItemText = styled(Text).withConfig({
  componentId: "sc-1qmri2f-4"
})(["display:block;max-width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
export { MobileAppliedFiltersListItem, MobileAppliedFiltersListItemText, MobileToggleResponsiveMenuButtonWrapper, StyledGroupItem, StyledToggleFilterPopupButton };